import axios from "axios";

const BASE_URL = "https://api.mshelhomes.com/api";

export default {
    
  /**
   * Create a new registration
   * @param {Object} body - The payload for the registration
   * @returns {Promise} Axios promise containing the response
   */
  createRegistration(body) {
    return axios.post(`${BASE_URL}/register-agent`, body);
  },

   /**
   * Fetch the list of business sectors
   * @returns {Promise} Axios promise containing the response
   */
   getCategory() {
    return axios.get(`${BASE_URL}/agent-categories`);
  },
}